import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { StoreModule } from "@ngrx/store";
import * as fromUserState from "./reducer";
import { EffectsModule } from "@ngrx/effects";
import { LoginEffects } from "./effects";
import { LoginService } from "@services/login.service";

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        StoreModule.forFeature(
            fromUserState.userStateFeatureKey,
            fromUserState.UserReducer,
        ),
        EffectsModule.forFeature([LoginEffects]),
    ],
    providers: [LoginService],
})
export class UserModule {}
